import React__default from 'react';
import { overlayArrowStyles } from './overlay-arrow.styles.esm.js';
import { OverlayArrow as _OverlayArrow } from '../popover/aria/overlay-arrow.esm.js';
import { usePopoverContext } from '../popover/popover-context.esm.js';

var OverlayArrow = function OverlayArrow() {
  var _usePopoverContext = usePopoverContext(),
    color = _usePopoverContext.color;
  var classes = overlayArrowStyles({
    color: color
  });
  return /*#__PURE__*/React__default.createElement(_OverlayArrow, {
    className: "group"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "csg-tw-overlay-arrow ".concat(classes)
  }));
};
var OverlayArrow$1 = OverlayArrow;

export { OverlayArrow$1 as default };
//# sourceMappingURL=overlay-arrow.esm.js.map
